import { X, Check } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const ROWS = [
  { label: "Qualité des profils", generic: false, us: true },
  { label: "Vitesse de livraison", generic: false, us: true },
  { label: "Respect des CGU des plateformes", generic: false, us: true },
  { label: "Garantie de remplacement", generic: false, us: true },
  { label: "Paiement sans mot de passe demandé", generic: false, us: true },
  { label: "Support client francophone", generic: false, us: true },
  { label: "Prix transparents, sans frais cachés", generic: false, us: true },
];

export default function ComparisonTable({ name, accentColor }) {
  const { t } = useLanguage();

  return (
    <div className="rounded-2xl border border-white/8 overflow-hidden" data-testid="comparison-table">
      <div className="grid grid-cols-[1fr_auto_auto] items-center">
        <div className="p-4 text-xs font-semibold text-zinc-500 uppercase tracking-wide">{t("network.comparison_criteria", "Critère")}</div>
        <div className="p-4 text-center text-sm font-semibold text-zinc-400 w-32">{t("network.comparison_generic", "Sites génériques")}</div>
        <div className="p-4 text-center text-sm font-bold text-white w-32" style={{ background: `${accentColor}22` }}>Buy Likes and Followers</div>
      </div>
      {ROWS.map((row, i) => (
        <div key={row.label} className={`grid grid-cols-[1fr_auto_auto] items-center ${i % 2 === 0 ? "bg-white/[0.02]" : ""}`} data-testid={`comparison-row-${i}`}>
          <div className="p-4 text-sm text-zinc-300">{t(`network.comparison_row_${i}`, row.label)}</div>
          <div className="p-4 flex justify-center w-32">
            {row.generic ? <Check className="w-4 h-4 text-emerald-400" /> : <X className="w-4 h-4 text-red-400" />}
          </div>
          <div className="p-4 flex justify-center w-32" style={{ background: `${accentColor}12` }}>
            {row.us ? <Check className="w-4 h-4" style={{ color: accentColor }} /> : <X className="w-4 h-4 text-red-400" />}
          </div>
        </div>
      ))}
    </div>
  );
}
